export const maintenance = {
  SET_MAINTENANCE_STATE: 'MAINTENANCE_SET_MAINTENANCE_STATE',
  SHOW_MAINTENANCE_MODAL: 'MAINTENANCE_SHOW_MAINTENANCE_MODAL',
  HIDE_MAINTENANCE_MODAL: 'MAINTENANCE_HIDE_MAINTENANCE_MODAL',
  NOTIFY_MAINTENANCE_MODAL: 'MAINTENANCE_NOTIFY_MAINTENANCE_MODAL',
};
